// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/app/app.proto" (package "mlmbox.client.app", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { App } from "./app.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Scheme } from "../../types/scheme.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.app.App
 */
export interface IAppClient {
    /**
     * @generated from protobuf rpc: SchemeInfo(google.protobuf.Empty) returns (mlmbox.types.Scheme);
     */
    schemeInfo(input: Empty, options?: RpcOptions): UnaryCall<Empty, Scheme>;
}
/**
 * @generated from protobuf service mlmbox.client.app.App
 */
export class AppClient implements IAppClient, ServiceInfo {
    typeName = App.typeName;
    methods = App.methods;
    options = App.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SchemeInfo(google.protobuf.Empty) returns (mlmbox.types.Scheme);
     */
    schemeInfo(input: Empty, options?: RpcOptions): UnaryCall<Empty, Scheme> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Scheme>("unary", this._transport, method, opt, input);
    }
}
